import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import ShieldIcon from '@mui/icons-material/Shield';
import LockIcon from '@mui/icons-material/Lock';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import FlashOnIcon from '@mui/icons-material/FlashOn';
export function FinalCTA() {
  return <section className="py-14 bg-brand-lightGray border-t border-gray-200" data-id="element-128">
      <div className="max-w-5xl mx-auto px-4 md:px-8" data-id="element-129">
        <div className="text-center mb-8" data-id="element-130">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-4 uppercase tracking-wider" data-id="element-131">
            ⏰ EL PRECIO CIERRA EN:
          </h2>
          <CountdownTimer data-id="element-132" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-133">
          {/* Standard Pack */}
          <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-200 flex flex-col text-center" data-id="element-134">
            <h3 className="text-xl font-serif font-bold text-brand-dark mb-1" data-id="element-135">
              📘 MIGA MASTER PRO
            </h3>
            <h4 className="text-sm font-bold text-brand-gray mb-4" data-id="element-136">
              2 Tomos + 3 Bonos · Técnica + Negocio completo
            </h4>

            <div className="mb-4" data-id="element-137">
              <div className="text-gray-400 line-through text-lg mb-1" data-id="element-138">
                ~~$45.000~~
              </div>
              <div className="text-4xl font-bold text-brand-dark" data-id="element-139">$19.999</div>
            </div>

            <a href="#pricing" className="w-full block bg-brand-dark hover:bg-black text-white font-bold py-4 px-6 rounded-xl transition-colors mt-auto" data-id="element-140">
              → QUIERO MI MIGA MASTER PRO
            </a>
          </div>

          {/* Elite Pack */}
          <div className="bg-brand-dark text-white rounded-2xl p-6 shadow-xl border border-brand-gold flex flex-col text-center relative overflow-hidden" data-id="element-141">
            <div className="absolute top-0 left-0 w-full bg-brand-gold text-brand-dark py-1 text-xs font-bold tracking-wider uppercase" data-id="element-142">
              Recomendado
            </div>
            <h3 className="text-xl font-serif font-bold text-brand-gold mb-1 mt-4" data-id="element-143">
              🏆 MIGA MASTER PRO + CATERING ELITE ⭐
            </h3>
            <h4 className="text-sm font-medium text-gray-300 mb-4" data-id="element-144">
              2 Tomos + 3 Bonos + Kit Catering Profesional
            </h4>

            <div className="mb-4" data-id="element-145">
              <div className="text-gray-400 line-through text-lg mb-1" data-id="element-146">
                ~~$65.000~~
              </div>
              <div className="text-4xl font-bold text-white" data-id="element-147">$29.999</div>
            </div>

            <a href="#pricing" className="w-full block bg-brand-gold hover:bg-brand-goldHover text-brand-dark font-bold py-4 px-6 rounded-xl transition-colors mt-auto shadow-lg" data-id="element-148">
              → QUIERO MIGA MASTER PRO + CATERING ELITE
            </a>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 text-sm text-brand-gray font-medium" data-id="element-149">
          <div className="flex items-center gap-2" data-id="element-150">
            <LockIcon fontSize="small" className="text-brand-gold" data-id="element-151" />
            <span data-id="element-152">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-153">
            <FlashOnIcon fontSize="small" className="text-brand-gold" data-id="element-154" />
            <span data-id="element-155">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-156">
            <ShieldIcon fontSize="small" className="text-brand-gold" data-id="element-157" />
            <span data-id="element-158">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2 w-full justify-center md:w-auto mt-4 md:mt-0" data-id="element-159">
            <CreditCardIcon fontSize="small" className="text-brand-gold" data-id="element-160" />
            <span data-id="element-161">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}